/*
 * @Description: 注册路由。 遍历views中的app.ts
                 meta: {
                  isLayout: true, // 布局容器。
                  noLayout: true, // 不会添加到layout路由中，例如登录。也不会匹配到动态路由生成。
                  parentPath: string, // 父级路由path，用于菜单、面包屑以及路由拦截。未在菜单中注册的路由需要使用该属性。例如列表 -> 详情，其中详情不会注册到菜单中，那么详情的parentPath应该是list的path。
                  isMenuSkip: false // 跳过菜单匹配拦截，用于不注册在菜单中的路由且毫无关联的路由。
                  isIndependent: true, // 独立启动，在微服务中使用，只有dev环境启动，方便调试。
                  isRelation: true, // 关系型路由，只会动态匹配顶级路由，children中路由不进行匹配。！！！路由修改，该属性暂时无用。
                  isDynamicContainer: true // 标识是否为自动生成的模块路由，未匹配到本地路由则会生成该模块。！！！路由修改，该属性暂时无用。
                  noSyncData: true, // 不需要同步数据，例如登录页。
                 }
 * @Date: 2021-09-15 14:35:55
 */
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { createRouterGuards } from './guide';
import { App, markRaw } from 'vue';
import layout from '@/layout/index.vue';
// linux打包时候总是提示类型异常，暂时处理

const views = (require as any).context('@/views', true, /app.js|app.ts$/);

const createRoutes = () => {
  const routes: Array<RouteRecordRaw> = [
    /* 
      方案一：通配路由，子应用路由不会在主应用中注册，所有主应用会出现route找不到的情况。
              问题：1、菜单不能用路由匹配，需要自己些菜单规则。
                    2、子应用route不能只有一级，需要有父级包含（只有一级其实也可以，还没写菜单匹配不确定有什么问题），并且父级对应的是后台注册的菜单code，这样才能满足平级路由且业务是父子关系的路由，例如列表/a/list、详情/a/detail，通过识别/a来处理对应菜单激活状态且能加载子应用，子通过redirect来设置默认展示页面，但是无法解决主应用识别业务层级关系 这个也无所谓。
      方案二：主应用加载子应用后，由子应用传给主应用路由配置，再有主应用注册路由。问题：需要主应用重新加载路由。
    */

    {
      path: '/industry/:pathMatch(.*)*',
      component: markRaw(layout),
      meta: { isLayout: true },
      children: []
    },
    {
      path: '/asp/:pathMatch(.*)*',
      component: markRaw(layout),
      meta: { isLayout: true },
      children: []
    },
    {
      path: '/supplier/:pathMatch(.*)*',
      component: markRaw(layout),
      meta: { isLayout: true },
      children: []
    }
  ];
  // const layoutRoute = routes.find(item => item.name === 'layout');
  const layoutRoute = {
    path: '/main',
    component: markRaw(layout),
    meta: { isLayout: true },
    children: []
  };
  views.keys().forEach(path => {
    const { route: curRoutes } = views(path);
    if (curRoutes) {
      curRoutes.forEach(route => {
        /*
        放于每个meta中判断，方便分离路由。
        开发时候设置这个数据后可以不用再模块配置，直接显示。提交代码记得删除
      */
        if (route.meta.noLayout) {
          routes.push(route);
        } else {
          layoutRoute.children.push(route);
        }
      });
    }

    // Array.prototype.push.apply(topLevel ? routes : routes[0].children, route);
  });

  routes.push(layoutRoute); // 直接注册，通过拦截处理url权限问题
  return routes;
};

const router = createRouter({
  //createWebHistory -- history模式
  //createWebHashHistory -- hash模式
  history: createWebHashHistory(),
  routes: createRoutes()
});
export default router;

export function setupRouter(app: App) {
  app.use(router);
  createRouterGuards(router);
  return router;
}
